import PropTypes from 'prop-types';
import React from 'react';
import { buildStyles, CircularProgressbarWithChildren } from 'react-circular-progressbar';
import useIncrement from '../../hook/useIncrement';
import TranslatedText from '../text/TranslatedText';
import './CircularProgressBar.css';

function CircularProgressBar({ content = '66', name, percentage }) {
  const progress = useIncrement(percentage);

  return (
    <div className="circular-bar-content">
      <CircularProgressbarWithChildren
        value={progress}
        styles={buildStyles({
          pathColor: 'var(--secondary-color)',
          trailColor: 'var(--grey300-color)',
        })}
      >
        <div className="circular-bar-center-content">
          {content}
        </div>
      </CircularProgressbarWithChildren>

      <div className="circular-bar-name">
        <TranslatedText txt={name} />
      </div>
    </div>
  );
}
CircularProgressBar.propTypes = {
  percentage: PropTypes.number.isRequired,
  content: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
};
export default CircularProgressBar;
